module.exports = __webpack_public_path__ + "img/any_bg.23f5d4c5.jpg";